module.exports = __webpack_public_path__ + "img/tuition-tutorial-05.682dc3a7.png";